import { useState } from "react";
import styles from "./../styles.module.css";
import CampoTextoLongo from "../../../../components/Campo/CampoTextoLongo";
import VerificaForm from "../../../../controllers/VerificaForm";

type Props = {
  voltarPagina: Function;
  aquisicaoObj: string;
  setAquisicao: React.Dispatch<React.SetStateAction<string>>;
  finalizar: (manutencao: string) => void;
};

function AquisicaoEquipamentos({
  voltarPagina,
  aquisicaoObj,
  setAquisicao,
  finalizar,
}: Props) {
  const [manutencao, setManutencao] = useState(aquisicaoObj || "");

  return (
    <div>
      <h2 className={styles.titulo}>
        6.2. <strong>Manutenção</strong> Preventiva :
      </h2>

      <CampoTextoLongo
        title="Manutenção Preventiva e Corretiva dos Equipamentos a Serem Adquiridos"
        placeholder="Descreva a Manutenção Preventiva e Corretiva"
        required={true}
        customValidity="Preencha com a Manutenção Preventiva e Corretiva"
        setter={setManutencao}
        value={manutencao}
      />

      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={(e) => {
            if (manutencao) {
              setAquisicao(manutencao);
            }

            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>

        <button
          className={styles.passarTelaBtn}
          onClick={(e) => {
            if (VerificaForm(e.currentTarget.form)) {
              setAquisicao(manutencao);
              finalizar(manutencao);
            }
          }}
        >
          Finalizar ❯❯
        </button>
      </div>
    </div>
  );
}

export default AquisicaoEquipamentos;
